import { envFlags } from '@thoughtspot/env-flags';
import { getExpiredAccountLifeDays as getExpiredAccountLifeDaysFromSessionService, getTotalTrialDays as getTotalTrialDaysFromSessionService, isOrgsOnFTEnabled as isOrgsOnFTEnabledFromSessionService, isTrialVersionEnabled as isTrialVersionEnabledFromSessionService, } from '@thoughtspot/session-service';
import { getFreeTrialV2ExperienceEnabled, isFreeTrialActivationEnabled as isFreeTrialActivationEnabledFromSessionService, } from '@thoughtspot/system-config-service';
import { getFeatureFlagValues, isFeatureEnabled } from './flags';
import { FEATURE_FLAG_NAMES } from './flags.const';
export const isOrgsOnFTEnabled = () => getFeatureFlagValues({ key: FEATURE_FLAG_NAMES.ENABLE_FREE_TRIAL_LD_FLAGS }, { key: FEATURE_FLAG_NAMES.ENABLE_ORGS_ON_FREE_TRIAL }, isOrgsOnFTEnabledFromSessionService());
export const isFreeTrialActivationEnabled = () => getFeatureFlagValues({ key: FEATURE_FLAG_NAMES.ENABLE_FREE_TRIAL_LD_FLAGS }, { key: FEATURE_FLAG_NAMES.FREE_TRIAL_ACTIVATION_ENABLED }, isFreeTrialActivationEnabledFromSessionService());
export const isTrialVersionEnabled = () => getFeatureFlagValues({ key: FEATURE_FLAG_NAMES.ENABLE_FREE_TRIAL_LD_FLAGS }, {
    key: FEATURE_FLAG_NAMES.TRIAL_VERSION_CONFIG,
    innerKey: 'enableTrialVersion',
}, isTrialVersionEnabledFromSessionService());
export const getExpiredAccountLifeDays = () => getFeatureFlagValues({ key: FEATURE_FLAG_NAMES.ENABLE_FREE_TRIAL_LD_FLAGS }, {
    key: FEATURE_FLAG_NAMES.TRIAL_VERSION_CONFIG,
    innerKey: 'expiredAccountLifeDays',
}, getExpiredAccountLifeDaysFromSessionService());
export const getTotalTrialDays = () => getFeatureFlagValues({ key: FEATURE_FLAG_NAMES.ENABLE_FREE_TRIAL_LD_FLAGS }, {
    key: FEATURE_FLAG_NAMES.TRIAL_VERSION_CONFIG,
    innerKey: 'trialAccountLifeDays',
}, getTotalTrialDaysFromSessionService());
export const isFreeTrialV2ExperienceEnabled = () => {
    return (isFeatureEnabled(FEATURE_FLAG_NAMES.ENABLE_FREE_TRIAL_V2_EXPERIENCE, {
        urlParamValue: envFlags.getValue(FEATURE_FLAG_NAMES.ENABLE_FREE_TRIAL_V2_EXPERIENCE),
    }) || getFreeTrialV2ExperienceEnabled());
};
export const getIsEnhancedSerpPage = () => {
    return isFeatureEnabled(FEATURE_FLAG_NAMES.ENABLE_ADVANCED_SERP);
};
export const getIsLazyLeftNavEnabled = () => {
    return isFeatureEnabled(FEATURE_FLAG_NAMES.ENABLE_LAZY_LEFT_NAV_PANELS);
};
export const isLbSequentialVizMountEnabled = () => isFeatureEnabled(FEATURE_FLAG_NAMES.ENABLE_LB_SEQUENTIAL_VIZ_MOUNT, {
    urlParamValue: envFlags.getValue(FEATURE_FLAG_NAMES.ENABLE_LB_SEQUENTIAL_VIZ_MOUNT),
});
export const isAnswerVerificationEnabled = () => isFeatureEnabled(FEATURE_FLAG_NAMES.ENABLE_ANSWER_VERIFICATION, {
    urlParamValue: envFlags.getValue(FEATURE_FLAG_NAMES.ENABLE_ANSWER_VERIFICATION),
});
export const isSpotqlAnswerEnabled = () => isFeatureEnabled(FEATURE_FLAG_NAMES.ENABLE_SPOTQL_ANSWER);
export const isKpiV2Enabled = () => isFeatureEnabled(FEATURE_FLAG_NAMES.ENABLE_KPI_V2, {
    urlParamValue: envFlags.getValue(FEATURE_FLAG_NAMES.ENABLE_KPI_V2),
});
export const getListTablePagesConfig = () => {
    const ldFlagValue = isFeatureEnabled(FEATURE_FLAG_NAMES.ENABLE_LIST_TABLE_PAGES);
    return {
        libraryList: true,
        answerList: true,
        liveboardList: true,
        liveboardSchedules: ldFlagValue?.liveboardSchedules ?? false,
        monitorSubscriptions: ldFlagValue?.monitorSubscriptions ?? false,
    };
};
//# sourceMappingURL=launchdarkly-store.js.map